export var EOrderSubType;
(function (EOrderSubType) {
    EOrderSubType[EOrderSubType["\u6709\u5355\u9000\u8D27"] = 3] = "\u6709\u5355\u9000\u8D27";
    EOrderSubType[EOrderSubType["\u65E0\u5355\u9000\u8D27"] = 4] = "\u65E0\u5355\u9000\u8D27";
})(EOrderSubType || (EOrderSubType = {}));
